import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-[#162c35] text-white pt-12 pb-6">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
                    {/* Contact Info */}
                    <div>
                        <h3 className="text-xl font-bold mb-4 text-[#8B5F13]">Casa Del Príncipe</h3>
                        <ul className="space-y-3">
                            <li className="flex items-start">
                                <MapPin className="w-5 h-5 mr-2 text-gray-400 flex-shrink-0 mt-1" />
                                <span className="text-gray-300 text-sm">
                                    C/ Alfonso XII, Nº 14, Local 5<br />
                                    28280, El Escorial, Madrid
                                </span>
                            </li>
                            <li className="flex items-center">
                                <Phone className="w-5 h-5 mr-2 text-gray-400" />
                                <span className="text-gray-300 text-sm">+34 91 890 12 34</span> {/* Placeholder phone */}
                            </li>
                            <li className="flex items-center">
                                <Mail className="w-5 h-5 mr-2 text-gray-400" />
                                <a href="mailto:atencion@casadelprincipe.com" className="text-gray-300 text-sm hover:text-white">atencion@casadelprincipe.com</a> {/* Placeholder email */}
                            </li>
                        </ul>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="text-xl font-bold mb-4 text-[#8B5F13]">Enlaces</h3>
                        <ul className="space-y-2">
                            <li><Link to="/propiedades" className="text-gray-300 hover:text-white transition-colors">Propiedades</Link></li>
                            <li><Link to="/contacto" className="text-gray-300 hover:text-white transition-colors">Contacto</Link></li>
                            <li><Link to="/privacidad" className="text-gray-300 hover:text-white transition-colors">Política de Privacidad</Link></li>
                            <li><Link to="/cookies" className="text-gray-300 hover:text-white transition-colors">Política de Cookies</Link></li>
                            <li><Link to="/terminos" className="text-gray-300 hover:text-white transition-colors">Términos y Condiciones</Link></li>
                        </ul>
                    </div>

                    {/* Social & Legal */}
                    <div>
                        <h3 className="text-xl font-bold mb-4 text-[#8B5F13]">Síguenos</h3>
                        <div className="flex space-x-4 mb-6">
                            <a href="https://www.facebook.com/profile.php?id=61583240171834" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                                <Facebook className="w-6 h-6" />
                            </a>
                            <a href="https://www.instagram.com/joancasadelprincipe" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                                <Instagram className="w-6 h-6" />
                            </a>
                        </div>
                        <p className="text-xs text-gray-500">
                            CIF: B21903265<br />
                            Estudio Casa Del Príncipe el Escorial S.L.
                        </p>
                    </div>
                </div>

                <div className="border-t border-gray-700 pt-6 text-center">
                    <p className="text-sm text-gray-500">
                        &copy; {currentYear} Casa Del Príncipe. Todos los derechos reservados.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
